import { Box, Chip, Tooltip, Typography, alpha, useTheme } from '@mui/material'
import { FC } from 'react'
import {
  getCollaboratorPermissionLabel,
  getCollaboratorPermissionLabels,
  getCollaboratorScreenPermissionKeys,
} from '../../../utils/collaborator-permissions'

interface ICollaboratorPermissionsCellProps {
  permissionsScreens?: string[]
  permissions?: string[]
  maxVisible?: number
}

export const CollaboratorPermissionsCell: FC<ICollaboratorPermissionsCellProps> = ({
  permissionsScreens = [],
  permissions = [],
  maxVisible = 3,
}) => {
  const theme = useTheme()
  const keys = getCollaboratorScreenPermissionKeys(permissionsScreens, permissions)
  const labels = getCollaboratorPermissionLabels(permissionsScreens, permissions)

  const displayLabels = labels.length
    ? labels
    : keys
        .map((key) => getCollaboratorPermissionLabel(key) || key.replace(/:manage$/, '').replace(/^menu:|^feature:/, ''))
        .filter(Boolean)

  if (!displayLabels.length) {
    return (
      <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>
        Sem acessos
      </Typography>
    )
  }

  const visible = displayLabels.slice(0, maxVisible)
  const hidden = displayLabels.slice(maxVisible)
  const isAdmin = displayLabels.some((l) => l.includes('completo') || l === 'Admin geral')

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        width: '100%',
        minWidth: 0,
      }}
    >
      {visible.map((label) => (
        <Chip
          key={label}
          label={label}
          size="small"
          sx={{
            height: 22,
            maxWidth: 120,
            fontSize: '0.65rem',
            fontWeight: 700,
            bgcolor: isAdmin
              ? alpha(theme.palette.secondary.main, 0.1)
              : alpha(theme.palette.primary.main, 0.08),
            color: isAdmin ? theme.palette.secondary.dark : theme.palette.primary.dark,
            '& .MuiChip-label': {
              px: 0.75,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
        />
      ))}
      {hidden.length > 0 && (
        <Tooltip title={displayLabels.join(' · ')} placement="top">
          <Chip
            label={`+${hidden.length}`}
            size="small"
            sx={{
              height: 22,
              fontSize: '0.65rem',
              fontWeight: 700,
              flexShrink: 0,
              bgcolor: alpha(theme.palette.text.primary, 0.06),
            }}
          />
        </Tooltip>
      )}
    </Box>
  )
}
